/* Wallstraight — Meta Pixel standard events (AddToCart, InitiateCheckout).
 * Purchase: primary = Shopify Facebook & Instagram channel (see docs/wk-oranje-meta-tracking.md).
 * trackPurchaseFromShopifyCheckout = legacy thank-you fallback only.
 * Standard event params: https://developers.facebook.com/docs/meta-pixel/reference
 * Custom WS_* events stay in ws-generator.js (trackCustom). */
(function(){
  'use strict';
  if(typeof window==='undefined')return;

  function currencyCode(){
    if(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active){
      return String(window.Shopify.currency.active);
    }
    var p=window.WS_VIEWCONTENT_PAYLOAD;
    if(p&&p.currency)return String(p.currency);
    return 'EUR';
  }

  function trackStandard(name,payload){
    if(typeof window.fbq!=='function')return false;
    try{
      window.fbq('track',String(name||''),payload&&typeof payload==='object'?payload:{});
      return true;
    }catch(_){return false;}
  }

  function payloadFromCartLine(variantId,parsed,fallbackCents){
    var currency=currencyCode();
    var valueCents=0;
    var vid=Number(variantId);
    if(parsed&&Array.isArray(parsed.items)){
      var line=null;
      for(var i=0;i<parsed.items.length;i++){
        if(Number(parsed.items[i].variant_id)===vid){line=parsed.items[i];break;}
      }
      if(!line&&parsed.items.length)line=parsed.items[0];
      if(line)valueCents=line.final_line_price||line.line_price||line.price||0;
    }else if(parsed&&typeof parsed.final_line_price==='number'){
      valueCents=parsed.final_line_price;
    }else if(Number.isFinite(fallbackCents)&&fallbackCents>0){
      valueCents=fallbackCents;
    }
    return {
      content_ids:[String(variantId)],
      content_type:'product',
      value:Math.max(0,valueCents)/100,
      currency:currency,
      num_items:1
    };
  }

  function trackAddToCart(variantId,parsed,fallbackCents){
    if(!variantId)return false;
    return trackStandard('AddToCart',payloadFromCartLine(variantId,parsed,fallbackCents));
  }

  function trackInitiateCheckout(cart){
    if(!cart||typeof cart!=='object')return false;
    var currency=cart.currency||currencyCode();
    var valueCents=typeof cart.total_price==='number'?cart.total_price:0;
    var ids=[];
    if(Array.isArray(cart.items)){
      for(var i=0;i<cart.items.length;i++){
        if(cart.items[i]&&cart.items[i].variant_id)ids.push(String(cart.items[i].variant_id));
      }
    }
    return trackStandard('InitiateCheckout',{
      content_ids:ids,
      content_type:'product',
      value:Math.max(0,valueCents)/100,
      currency:currency,
      num_items:typeof cart.item_count==='number'?cart.item_count:ids.length||1
    });
  }

  /** Checkout thank-you / Additional scripts — Shopify.checkout on legacy thank_you page. */
  function trackPurchaseFromShopifyCheckout(){
    if(typeof window.Shopify==='undefined'||!window.Shopify.checkout)return false;
    var page=window.Shopify.Checkout&&window.Shopify.Checkout.page;
    var step=window.Shopify.Checkout&&window.Shopify.Checkout.step;
    if(page!=='thank_you'&&step!=='thank_you')return false;
    var key='ws_meta_purchase_'+String(window.Shopify.checkout.order_id||window.Shopify.checkout.token||'');
    try{if(sessionStorage.getItem(key)==='1')return false;}catch(_){}
    var c=window.Shopify.checkout;
    var value=parseFloat(c.total_price||c.payment_due||0);
    if(!Number.isFinite(value))value=0;
    var currency=String(c.currency||currencyCode());
    var ids=[];
    if(Array.isArray(c.line_items)){
      for(var j=0;j<c.line_items.length;j++){
        if(c.line_items[j]&&c.line_items[j].variant_id)ids.push(String(c.line_items[j].variant_id));
      }
    }
    var ok=trackStandard('Purchase',{
      content_ids:ids,
      content_type:'product',
      value:value,
      currency:currency,
      num_items:ids.length||1
    });
    if(ok){try{sessionStorage.setItem(key,'1');}catch(_){}}
    return ok;
  }

  window.wsMetaStandardEvents={
    currencyCode:currencyCode,
    trackStandard:trackStandard,
    trackAddToCart:trackAddToCart,
    trackInitiateCheckout:trackInitiateCheckout,
    trackPurchaseFromShopifyCheckout:trackPurchaseFromShopifyCheckout
  };

  trackPurchaseFromShopifyCheckout();
})();
